// modules/import/index.ts — Platik-IA
// Importa transacciones desde un Google Sheet existente (migración desde v2).

import { bus }       from '../../core/event-bus';
import { getModule } from '../../core/registry';
import { putTransaction } from '../../services/idb';
import { readAllTransactions, backfillSheetIds } from '../../services/google-sheets';
import { uuid } from '../../shared/utils/format';
import type { ImportAPI } from './contracts';

export async function initImport(): Promise<ImportAPI> {
  bus.emit('import:ready');

  return {
    async importFromSheetId(sheetId: string): Promise<number> {
      const auth  = getModule<{ getAccessToken: () => Promise<string | null> }>('auth');
      const token = await auth?.getAccessToken();
      if (!token) throw new Error('No hay sesión de Google activa');

      bus.emit('import:started');
      bus.emit('notifications:show', { message: 'Importando datos desde tu Drive…', type: 'info' });

      try {
        await backfillSheetIds(token, sheetId);   // IDs estables (compat v2) → re-importar no duplica
        const sheetTxs = await readAllTransactions(token, sheetId);
        const total    = sheetTxs.length;

        for (let i = 0; i < total; i++) {
          const stx = sheetTxs[i];
          await putTransaction({
            id:           stx.id || uuid(),
            fecha:        stx.fecha,
            tipo:         stx.tipo,
            monto:        stx.monto,
            descripcion:  stx.descripcion,
            categoria:    stx.categoria,
            subcategoria: stx.subcategoria,
            syncStatus:   'synced',
            syncedAt:     new Date().toISOString(),
            createdAt:    stx.fecha,
          });

          if (i % 10 === 0) bus.emit('import:progress', { current: i + 1, total });
        }

        bus.emit('import:completed', { count: total });
        bus.emit('notifications:show', { message: `${total} movimientos importados ✓`, type: 'success' });
        return total;
      } catch (err) {
        const msg = err instanceof Error ? err.message : 'Error desconocido';
        bus.emit('import:error', { message: msg });
        bus.emit('notifications:show', { message: `Error al importar: ${msg}`, type: 'error' });
        throw err;
      }
    },

    dispose() {},
  };
}
